<template>
    <div class="dashboard">
        <h1>{{ contents[contentsType].title }}変更</h1>
        <ValidationObserver ref="observer" v-slot="{ invalid }" tag="div">
            <div class="l-w5 l-2-20-t--all">
                <div>
                    <h2>日付</h2>
                    <div class="l-mt2 l-mb8">
                        <input v-model="input.delivery_destination_date" type="date" :disabled="flagDisabled">
                    </div>
                    <h2>現場名</h2>
                    <div class="l-mt2 l-mb8">
                        <input v-model="input.delivery_destination_name" type="text" :disabled="flagDisabled">
                    </div>
                    <h2>施工業者</h2>
                    <div class="l-mt2 l-mb8">
                        <input v-model="input.contractor" type="text" :disabled="flagDisabled">
                    </div>
                    <h2>車両ID</h2>
                    <div class="l-mt2 l-mb8">
                        <input v-model="input.vehicle_id" type="text" :disabled="flagDisabled">
                    </div>
                    <h2>ドライバー</h2>
                    <div class="l-mt2 l-mb8">
                        <select v-model="input.driver_id" :disabled="flagDisabled">
                            <option v-for="(data, key) in listDrivers" :key="key" :value="data.driver_id">{{ data.driver_name }}</option>
                        </select>
                    </div>
                </div>
                <div class="is-left">
                    <h2>納入量</h2>
                    <ValidationProvider v-slot="{ errors }" class="l-mt2 l-mb8" name="納入量" rules="max_value:999999999.9|min_value:0.01|required" tag="div" :immediate="$_getValidatedImmediate()">
                        <input v-model="input.delivery_allocations_amount" type="number" step="0.01">
                        <p class="errorMessage">{{ errors[0] }}</p>
                    </ValidationProvider>
                    <h2>工場発時刻</h2>
                    <div class="l-mt2 l-mb8">
                        <input v-model="input.residual_water_time" type="time">
                    </div>
                    <h2>現場着時刻</h2>
                    <div class="l-mt2 l-mb8">
                        <input v-model="input.site_arrival_time" type="time">
                    </div>
                    <h2>現場発時刻</h2>
                    <div class="l-mt2 l-mb8">
                        <input v-model="input.site_departure_time" type="time">
                    </div>
                    <h2>工場着時刻</h2>
                    <div class="l-mt2 l-mb8">
                        <input v-model="input.factory_arrival_time" type="time">
                    </div>
                </div>
            </div>
            <div class="l-mt6 l-2-00-m--all">
                <div>
                    <button :class="`${classButtonStyle}cancel`" type="button" @click="$_goBack()">戻る</button>
                    <button :class="X_validatedButtonStyle" type="button" :disabled="$_setValidatedDisabled(invalid)" @click="$_modalOpen(contents[contentsType].modal.update)">次へ</button>
                </div>
                <div>
                    <button :class="`${classButtonStyle}delete`" type="button" @click="$_modalOpen(contents[contentsType].modal.delete)">削除する</button>
                </div>
            </div>
        </ValidationObserver>
        <Modal :modal="modal" @action="modalAction($event)" @close="$_modalClose()" />
    </div>
</template>

<script>
    "use strict";

    import common from "@/mixins/common";

    const contents = {
        "allocations": {
            "modal": {
                "update": "updateDeliveryAllocations",
                "delete": "deleteDeliveryAllocations",
            },
            "title": "配車",
        },
        "daily_reports": {
            "modal": {
                "update": "updateDailyReports",
                "delete": "deleteDailyReports",
            },
            "title": "運転日報",
        },
    };

    export default {
        "mixins": [
            common,
        ],
        "props": {
            "id": {
                "required": true,
                "type": String,
            },
        },
        data() {
            return {
                "classButtonStyle": "button--oval--",
                "contents": contents,
                "contentsType": "allocations",
                "flagDisabled": true,
                "input": {},
                "listDrivers": [],
            };
        },
        created() {
            this.fetchingListDrivers();
            this.fetchingDataDeliveryAllocations();
            if (this.$route.query.source === "daily_reports") {
                // 配車変更画面から運転日報変更画面へ切り替え
                this.contentsType = "daily_reports";
            }
        },
        "methods": {
            modalAction(key) {
                if (key === "updateDeliveryAllocations" || key === "updateDailyReports") {
                    this.handleUpdate();
                } else if (key === "deleteDeliveryAllocations" || key === "deleteDailyReports") {
                    this.handleDelete();
                } else if (key === "updateDeliveryAllocations--finished" || key === "deleteDeliveryAllocations--finished" || key === "updateDailyReports--finished" || key === "deleteDailyReports--finished") {
                    if (this.$route.query.source === "daily_reports") {
                        this.$router.push({ "name": "offices_daily_reports_list" });
                    } else {
                        this.$router.push({ "name": "offices_delivery_allocations_list" });
                    }
                }
            },
            fetchingListDrivers() {
                // 全ドライバーデータ取得
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/drivers`,
                    this.$_requestConfig()
                ).then(response => {
                    this.listDrivers = response.data;
                }).catch(() => {
                    this.$_modalError("fetchingDriversError");
                });
            },
            fetchingDataDeliveryAllocations() {
                // 個別納入割当データ取得
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/delivery_allocations/${this.id}`,
                    this.$_requestConfig()
                ).then(response => {
                    this.input = response.data;
                }).catch(() => {
                    this.$_modalError("fetchingDeliveryAllocationsError");
                });
            },
            handleUpdate() {
                const date = this.input.delivery_destination_date;
                const unionData = Object.assign({}, this.input);
                if (this.input.factory_departure_time) {
                    unionData.factory_departure_time = `${date} ${this.input.factory_departure_time}`;
                }
                if (this.input.site_arrival_time) {
                    unionData.site_arrival_time = `${date} ${this.input.site_arrival_time}`;
                }
                if (this.input.site_departure_time) {
                    unionData.site_departure_time = `${date} ${this.input.site_departure_time}`;
                }
                if (this.input.factory_arrival_time) {
                    unionData.factory_arrival_time = `${date} ${this.input.factory_arrival_time}`;
                }
                if (this.input.residual_water_time) {
                    unionData.residual_water_time = `${date} ${this.input.residual_water_time}`;
                }
                // 個別納入割当データ変更
                common.$_axios.post(
                    `${common.$_configs.apiUrl}/delivery_allocations/${this.id}`,
                    unionData,
                    this.$_requestConfig()
                ).then(() => {
                    this.$_modalFinished();
                }).catch(() => {
                    this.$_modalError();
                });
            },
            handleDelete() {
                // 個別納入割当データ削除
                common.$_axios.delete(
                    `${common.$_configs.apiUrl}/delivery_allocations/${this.id}`,
                    this.$_requestConfig()
                ).then(() => {
                    this.$_modalFinished();
                }).catch(() => {
                    this.$_modalError();
                });
            },
        },
    };
</script>
